export const brandTokens = {
  blue0: '#F2F7FF',
  blue1: '#D9E7FA',
  blue2: '#B5D0F6',
  blue3: '#90B9F1',
  blue4: '#6CA2ED',
  blue5: '#488BE8',
  blue6: '#004AB1',
  blue7: '#003B8D',
  blue8: '#002962',
  blue9: '#001532',

  gray0: '#FAFBFF',
  gray1: '#F3F5FA',
  gray2: '#E3E7F2',
  gray3: '#D7D9EC',
  gray4: '#C0C0D7',
  gray5: '#B0B0CB',
  gray6: '#9595B1',
  gray7: '#7E7E9B',
  gray8: '#706B84',
  gray9: '#545067',

  green0: '#F4FFF2',
  green1: '#E6F4E8',
  green2: '#CDE9D1',
  green3: '#B3E0BA',
  green4: '#96D4A0',
  green5: '#79C886',
  green6: '#049B22',
  green7: '#016A1C',
  green8: '#005016',
  green9: '#00300F',

  red0: '#FFF2F3',
  red1: '#FFD2D7',
  red2: '#FABEC4',
  red3: '#F799A1',
  red4: '#F4737E',
  red5: '#F14D5B',
  red6: '#B1000F',
  red7: '#8D000C',
  red8: '#620008',
  red9: '#320004',

  tekhelet0: '#EEECF9',
  tekhelet1: '#CCC7E0',
  tekhelet2: '#A8A0C9',
  tekhelet3: '#8479B2',
  tekhelet4: '#7569A3',
  tekhelet5: '#655A94',
  tekhelet6: '#564A85',
  tekhelet7: '#463A76',
  tekhelet8: '#271B58',
  tekhelet9: '#090613',

  tomato0: '#FDF1F1',
  tomato1: '#FDDDD5',
  tomato2: '#FABFAE',
  tomato3: '#F8A087',
  tomato4: '#F68261',
  tomato5: '#F4633A',
  tomato6: '#E93D0D',
  tomato7: '#B42F0A',
  tomato8: '#7F2107',
  tomato9: '#491304',

  vistaBlue0: '#E9F0F9',
  vistaBlue1: '#DFE8F3',
  vistaBlue2: '#D4E0EF',
  vistaBlue3: '#BED0E6',
  vistaBlue4: '#A7C1DE',
  vistaBlue5: '#7BA1CD',
  vistaBlue6: '#5284BE',
  vistaBlue7: '#3B689D',
  vistaBlue8: '#2C4D74',
  vistaBlue9: '#1C324B',

  yellow0: '#FFFBF2',
  yellow1: '#FFEDD9',
  yellow2: '#FBE1C5',
  yellow3: '#F8CD9F',
  yellow4: '#F6BA79',
  yellow5: '#F3A653',
  yellow6: '#BA5900',
  yellow7: '#943C00',
  yellow8: '#7D2E00',
  yellow9: '#4A1500',

  royalPurple0: '#EFE9F6',
  royalPurple1: '#E7DEF3',
  royalPurple2: '#DCCFED',
  royalPurple3: '#C7B1E3',
  royalPurple4: '#B193D8',
  royalPurple5: '#9C75CD',
  royalPurple6: '#8657C2',
  royalPurple7: '#6A3CA5',
  royalPurple8: '#502D7C',
  royalPurple9: '#351E53',
}
